
import { useState, useEffect } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-white/80 backdrop-blur-xl shadow-[0_1px_0_rgba(0,0,0,0.06)]'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 lg:px-12 xl:px-20">
        <div className="flex items-center justify-between h-16">
          <a href="#home" className="cursor-pointer">
            <img
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/332f65bd5c6c697fc606d8fa0ef7c66b.png"
              alt="VAZ Global Capital"
              className="h-14 w-auto object-contain"
            />
          </a>

          <div className="hidden md:flex items-center gap-10">
            {['Home', 'Industries', 'Framework'].map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                className={`text-xs font-medium tracking-wide uppercase transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                  isScrolled
                    ? 'text-[#1d1d1f] hover:text-[#D4AF37]'
                    : 'text-white/90 hover:text-[#D4AF37]'
                }`}
              >
                {item}
              </a>
            ))}
            <a
              href="#consultation"
              className="text-xs font-semibold tracking-wide uppercase bg-[#D4AF37] text-[#0A1A3F] px-5 py-2 rounded-full hover:bg-[#C19B2E] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Consultation
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            aria-label="Menu"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl ${isScrolled ? 'text-[#1d1d1f]' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-white z-40">
          <div className="flex flex-col items-center pt-16 gap-8">
            {['Home', 'Industries', 'Framework', 'Consultation'].map((item) => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                onClick={() => setMobileOpen(false)}
                className="text-sm font-medium tracking-wide uppercase text-[#1d1d1f] hover:text-[#D4AF37] transition-colors cursor-pointer"
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
